import Vue from "vue";
import router from "./router";
import "./plugins/vuetify";
import App from "./App.vue";
import Chat from "vue-beautiful-chat";
import Firebase from "firebase/app";
import "firebase/auth";
import { store } from "./store/store";
import axios from "axios";
import VueParticles from "vue-particles";
import VueTour from "vue-tour";
import VueWaypoint from 'vue-waypoint'


Vue.use(VueWaypoint)


require("vue-tour/dist/vue-tour.css");
Vue.use(VueTour);

Vue.use(VueParticles);

Vue.use(Chat);





Vue.config.productionTip = false;

axios.defaults.baseURL = "https://showroom.privately.swiss/api";
// axios.defaults.baseURL = "http://localhost:5001";

if (process.env.TEXTLABEL_SERVER_URL) {
  axios.defaults.baseURL = process.env.TEXTLABEL_SERVER_URL;
} else if (process.env.NODE_ENV === "development") {
  axios.defaults.baseURL = "http://0.0.0.0:8080/showroom/";
  axios.defaults.timeout = 1000 * 60 * 10;
}

// Firebase config - this is provided when you create your app
// Swap out these settings for your project settings
var config = {
  apiKey: "AIzaSyBxhWcoGMMftLX0emVenO2edNcJ0pT7Dac",
  authDomain: "textlabel-a905d.firebaseapp.com",
  databaseURL: "https://textlabel-a905d.firebaseio.com",
  projectId: "textlabel-a905d",
  storageBucket: "",
  messagingSenderId: "327100937959"
};
// Initialize Firebase
Firebase.initializeApp(config);
let app;
Firebase.auth().onAuthStateChanged(function(user) {
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      render: h => h(App),
      created() {
        if (user) {
          store.dispatch("authentication/setUser");
        }
      },
      router,
      store
    }).$mount("#app");
  }
});
